<template>
  <van-overlay :show="Statementshow">
    <div class="wrapper">
      <div class="title">
        <van-image class="backImg" :src="objImg.titleImg" />
        <van-image class="fontImg" :src="objImg.titleFontImg" />
      </div>
      <p class="fontContent">
        本网站可能包含第三方所有的内容(如:文章、数据或摘要)，也可能包含进入第三方网站的超文本链接。我们提供此类第三方所有的内容及链接是向您提供便利，我们对本网站获取的或可用的任何第三方网站或内容没有控制权，因此，本网站不予认可、保证、推荐或承担关于这类第三方网站或内容或网站可用性的任何责任。尤其由于任何第三方所有的内容(无论是公布于本网站或其他网站)侵犯了任何人的知识产权的任何主张或者包含在第三方网站或内容中的任何信息或观点而引起的责任，本网站将不予承担。如您认为第三方网站提供的信息或内容涉及侵犯您的权利或任何违反法律法规的内容的，您可以通过本网站提供的联系方式通知我们，我们将会根据您提供构成侵权或违反法律法规的初步证据判断采取予以删除、屏蔽、断开链接等必要措施予以处理。
      </p>
      <div class="btn">
        <van-button @click="gotItFn('取消')">取消</van-button>
        <van-button type="primary" @click="gotItFn('确定')">确定</van-button>
      </div>
    </div>
  </van-overlay>
</template>

<script setup>
import titleImg from "../assets/image/C-title.png";
import titleFontImg from "../assets/image/C-title-font.png";
import { ref } from "vue";
const objImg = ref({
  titleImg,
  titleFontImg,
});
const Statementshow = ref();
const popup = ref();
const gotItFn = (val) => {
  switch (val) {
    case "取消":
      Statementshow.value = false;
      break;

    case "确定":
      Statementshow.value = false;
      switch (popup.value) {
        case "popupOne":
          localStorage.setItem("popupOne", Statementshow.value);
          break;
        case "popupTwo":
          localStorage.setItem("popupTwo", Statementshow.value);
          break;

        default:
          break;
      }
      break;
  }
};
const init = (val, flag) => {
  Statementshow.value = val;
  popup.value = flag;
};
defineExpose({
  init,
});
</script>
<style lang="less">
.van-overlay {
  z-index: 100 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;

  .wrapper {
    width: 320px;
    // height: 550px;
    height: 75vh;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 20px;
    background: #fff;
    border-radius: 10px;
    // position: relative;
    animation: movepopup 1s;
    background: linear-gradient(
      180deg,
      #d6ecff 0%,
      #f5f9ff 13%,
      #ffffff 38%,
      #ffffff 100%
    );

    .title {
      position: relative;
      z-index: 1;
      .backImg {
        width: 320px;
        // height: 102px;
        position: absolute;
        top: -13px;
        left: 0;
        z-index: 0;
      }
      .fontImg {
        width: 80px;
        height: 16px;
        margin: 24px 0 31px 19px;
      }
    }

    .fontContent {
      margin: 0 10px 27px 18px;
      font-size: 14px;
      color: #372b2f;
      line-height: 24px;
      position: relative;
      z-index: 2;
      font-family: Source Han Sans CN, Source Han Sans CN;
      // height: 200px;
      // overflow: scroll;
      // // -webkit-overflow-scrolling: touch;
      // // touch-action: auto;
      // scrollbar-width: thin;
      // // scroll-behavior: auto;
    }

    .btn {
      // position: absolute;
      // bottom: 18px;
      // right: 14px;
      // display: flex;
      text-align: right;
      padding-right: 20px;
      .van-button {
        width: 88px;
        height: 36px;
        border-radius: 10px;
        :deep(span) {
          font-size: 14px;
          color: #fff;
        }
      }
      .van-button:last-child {
        background-color: #437beb;
        border: none;
        margin-left: 10px;
        :deep(span) {
          font-size: 14px;
          color: #fff;
        }
      }
    }

    // .van-button {
    //   position: absolute;
    //   bottom: 18px;
    //   right: 14px;
    //   width: 88px;
    //   height: 36px;
    //   background-color: #437beb;
    //   border-radius: 10px;
    //   border: none;
    //   :deep(span) {
    //     font-size: 14px;
    //     color: #fff;
    //   }
    // }
  }
}

@keyframes movepopup {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
</style>
